export default __webpack_public_path__ + "static/media/Logo5.ea1896ac.png";